import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const TYPE_LABEL = { cash: "Nakit Kasa", bank: "Banka", card: "Kredi Kartı" };
let cache = null;
export const loadAccounts = async (force) => {
  if (!cache || force) cache = (await api.get("/cashbook/accounts")).data;
  return cache;
};
export const clearAccountsCache = () => { cache = null; };

export default function AccountSelect({ value, onChange, testId = "account-select", types, placeholder = "Hesap seçin" }) {
  const [accounts, setAccounts] = useState([]);
  useEffect(() => { loadAccounts().then(setAccounts).catch(() => setAccounts([])); }, []);
  const list = accounts.filter((a) => a.active !== false && (!types || types.includes(a.type)));
  useEffect(() => {
    if (!value && list.length) { const def = list.find((a) => a.type === "cash") || list[0]; onChange(def.id, def); }
    /* eslint-disable-next-line */ }, [accounts]);
  return (
    <Select value={value || ""} onValueChange={(v) => onChange(v, list.find((a) => a.id === v))}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {["cash", "bank", "card"].map((t) => list.filter((a) => a.type === t).map((a) => (
          <SelectItem key={a.id} value={a.id}><span className="text-muted-foreground text-xs mr-1.5">{TYPE_LABEL[t]} ·</span>{a.name}</SelectItem>
        )))}
      </SelectContent>
    </Select>
  );
}
